module.exports = __webpack_public_path__ + "img/泵头c.28a9f822.svg";